"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityStreamCloseButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Popover_1 = require("../../components/Popover");
var MDIcon_1 = require("../../components/MDIcon");
var ActivityStreamCloseButton = function (_a) {
  var onClose = _a.onClose,
    _b = _a.closeButtonTooltip,
    closeButtonTooltip = _b === void 0 ? "Close activity stream" : _b;
  var _c = __read((0, react_1.useState)(false), 2),
    hoverCloseButton = _c[0],
    setHoverCloseButton = _c[1];
  return onClose ? (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
    interactive: false,
    shown: hoverCloseButton,
    tooltip: true,
    placement: "bottom-end",
    content: closeButtonTooltip
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      className: "vsx-activity-stream-close-icon",
      onMouseEnter: function () {
        return setHoverCloseButton(true);
      },
      onMouseLeave: function () {
        return setHoverCloseButton(false);
      },
      onClick: function () {
        onClose();
        setHoverCloseButton(false);
      },
      icon: "close"
    })
  })) : null;
};
exports.ActivityStreamCloseButton = ActivityStreamCloseButton;